<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>代理商档案修改</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.back()">返回</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="formBox">
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-position="left"
                   :rules="rules"
                   style="padding:20px;background:#fff"
                   label-width="180px">
            <el-row :gutter="60">
              <el-col :span="12">
                <el-form-item label="登记日期："
                              prop="registDate">
                  <el-date-picker v-model="form.registDate"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
                <el-form-item label="区域："
                              prop="provinceCode">
                  <el-select v-model="form.provinceCode"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in provinces"
                               :key="item.code"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              <el-col>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商姓名/营业执照名称：">
                  <el-input v-model="form.agentName"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商身份证号/营业执照号码：">
                  <el-input v-model="form.agentCard"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商银行卡账户名称：">
                  <el-input v-model="form.bankAccountName"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商银行卡开户行及支行：">
                  <el-input v-model="form.bankName"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收款账号：">
                  <el-input v-model="form.receivePaymentAccount"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商手机号码：">
                  <el-input v-model="form.phoneNumber"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商收件地址：">
                  <el-input v-model="form.receiveAddress"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同编号：">
                  <el-input v-model="form.contractNumber"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理合同分成比例：">
                  <el-input v-model="form.contractRate" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="我方公司名称：">
                  <el-input v-model="form.ourCompanyName"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开票信息：">
                  <el-input v-model="form.billInfo"
                            placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上级代理商：">
                  <el-select v-model="form.superiorAgentId"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="销售负责人："
                              prop="saleId">
                  <el-select v-model="form.saleId"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="ax_default line1"></div>
            <el-form-item>
              <div style="text-align:center">
                <el-button @click="$router.back()">取消</el-button>
                <el-button @click="submitForm('form')"
                           type="primary">保存</el-button>
              </div>

            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { postQueryDeal, putAgent, getAgent, getprovince, getUserNames } from '../../../API'
    export default {
        data () {
            return {
                activeIndex: this.$route.path,
                name: '新增',
                form: {
                    registDate: '',
                    provinceCode: '',
                    provinceName: '',
                    agentName: '',
                    agentCard: '',
                    bankAccountName: '',
                    bankName: '',
                    receivePaymentAccount: '',
                    phoneNumber: '',
                    receiveAddress: '',
                    contractRate: '',
                    contractNumber: '',
                    ourCompanyName: '',
                    billInfo: '',
                    superiorAgentId: '',
                    superiorAgentName: '',
                    saleId: '',
                    saleName: '',
                },
                rules: {
                    registDate: { required: true, message: '必填', trigger: 'change' },
                    provinceName:{ required: true, message: '必填', trigger: 'blur' },
                    agentName:{ required: true, message: '必填', trigger: 'blur' },
                    agentCard:{ required: true, message: '必填', trigger: 'blur' },
                    contractRate:{ required: true, message: '必填', trigger: 'blur' },
                    contractNumber:{ required: true, message: '必填', trigger: 'blur' },
                    saleName:{ required: true, message: '必填', trigger: 'blur' },
                },
                provinces: [],
                userNames: []
            }
        },
        created () {
            if (localStorage.getItem('agentInfoId') !== null) {
                this.name = '修改'
                getAgent(localStorage.getItem('agentInfoId')).then(res => {
                    if (res.code == 0) {
                        this.form = res.data
                    }
                })
            }
            getprovince().then(res => {
                if (res.code === 0) {
                    this.provinces = res.data
                }
            })
            getUserNames().then(res => {
                if (res.code === 0) {
                    this.userNames = res.data
                }
            })
        },
        methods: {
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (localStorage.getItem('agentInfoId')) {
                            this.form.provinceName = _.find(this.provinces, { code: this.form.provinceCode.toString() }).name;
                            let tempUsername
                            let tempsaleId = this.form.saleId;
                            _(this.userNames).forEach(function(item){
                                if (item.userId == tempsaleId) {
                                    tempUsername = item.username;
                                }
                            })
                            this.form.saleName = tempUsername
                            let tempUpname
                            let tempUpId = this.form.superiorAgentId;
                            _(this.userNames).forEach(function(item){
                                if (item.userId == tempUpId) {
                                    tempUpname = item.username;
                                }
                            })
                            this.form.superiorAgentName = tempUpname
                            // let findObj = _.find(this.userNames, {userId: this.form.saleId.toString()})  todo 获取不到数据，待查


                            putAgent(this.form).then(res => {
                                if (res.code === 0) {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    let that = this
                                    setTimeout(
                                        function () {
                                            that.$router.back()
                                        }, 1000
                                    )
                                }
                            })

                        }
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>
<style lang='less' scoped>
  .header {
    height: 50px;
    line-height: 50px;
    background: rgb(243, 243, 243);
    padding: 0 20px;
    border: 1px solid rgba(228, 228, 228, 1);
  }
  .reload {
    background-color: rgba(236, 240, 245, 1);
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    font-weight: 650;
    font-style: normal;
    font-size: 24px;
    color: #3498db;
  }
  .formBox {
    border: 1px solid #e4e4e4;
    border-top: 7px solid #3498db;
  }
  /deep/ .el-breadcrumb__item {
    float: none;
  }
  .container {
    border: none;
    background-color: rgba(236, 240, 245, 1);
    padding: 0 0;
  }
  .leftLine {
    border-left: 5px solid rgba(52, 152, 219, 1);
    padding-right: 10px;
  }

  .form {
    background-color: #fff;
    border: 1px solid rgba(228, 228, 228, 1);
    padding: 20px;
  }
  .el-breadcrumb {
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    color: #999;
    background-color: rgba(236, 240, 245, 1);
    margin-left: 20px;
  }
  .header {
    font-weight: 700;
    font-style: normal;
    color: #5e5e5e;
  }
  .ax_default {
    font-family: "ArialMT", "Arial";
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    border-bottom: 1px solid#333333;
    text-align: center;
    line-height: normal;
  }
  .line1 {
    height: 1px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  /deep/ .el-input {
    width: 200px;
  }
  .pagination {
    float: right;
    /deep/ .el-pagination.is-background .btn-prev:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-prev {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #409eff;
    }
  }
</style>
